// app/assets/javascripts/leads_scheduled.js - VERSÃO CORRIGIDA
import axios from "axios";
import {
  enableSelect,
  disableSelect,
  clearSelectElTarget,
  clearEl,
} from "./attendance_concerns";

// Cache para armazenar dados já carregados
const dataCache = {
  groups: new Map(),
  dealers: new Map(),
  sellers: new Map(),
};

// Debounce para evitar múltiplas requisições
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

function initBackToTop() {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    if (window.scrollY > 300) btn.classList.add('show'); else btn.classList.remove('show');
  });
  btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
}

const fnScheduledFilters = () => {
  const companyEl = document.querySelector("#scheduled_lead_company_id_eq");
  const groupEl = document.querySelector("#scheduled_lead_dealer_group_id_eq");
  const dealerEl = document.querySelector("#scheduled_lead_dealer_id_eq");
  const sellerEl = document.querySelector("#scheduled_lead_user_id_eq");

  const hiddenGroup = document.querySelector("#q_moveable_of_Lead_type_dealer_group_id_eq");
  const hiddenDealer = document.querySelector("#q_moveable_of_Lead_type_dealer_id_eq");
  const hiddenUser = document.querySelector("#q_moveable_of_Lead_type_user_id_eq");


  if (companyEl || groupEl || dealerEl) {

    const BASE_URL = "searches";

    // Flag para evitar loops de atualização
    let isUpdating = false;

    const init = () => {
      // Inicialização mais eficiente
      const urlParams = new URLSearchParams(window.location.search);

      const groupId = urlParams.get('q[moveable_of_Lead_type_group_company_id_eq]');
      const dealerId = urlParams.get('q[moveable_of_Lead_type_dealer_id_eq]');
      const sellerId = urlParams.get('q[moveable_of_Lead_type_user_id_eq]');

      // Se há parâmetros na URL, carrega os dados em paralelo quando possível
      if (groupId) {
        loadInitialDataOptimized(groupId, dealerId, sellerId);
      } else {
        // Estado inicial
        disableSelect(groupEl);
        disableSelect(dealerEl);
        if (sellerEl) disableSelect(sellerEl);
        if (!hiddenGroup) clearSelectElTarget(groupEl, "Selecione primeiro o Grupo");
        if (!hiddenDealer) clearSelectElTarget(dealerEl, "Selecione primeiro a Empresa");
        if (sellerEl && !hiddenUser) clearSelectElTarget(sellerEl, "Selecione primeiro a Revenda");
      }

      // Adiciona handlers com debounce
      if (companyEl) companyEl.addEventListener("change", debounce(handleCompanyChange, 300));
      if (groupEl) groupEl.addEventListener("change", debounce(handleGroupChange, 300));
      if (dealerEl) dealerEl.addEventListener("change", debounce(handleDealerChange, 300));
    };

    const loadInitialDataOptimized = async (groupId, dealerId, sellerId) => {
      try {
        // Mostra loading
        showLoading(dealerEl, "Carregando revendas...");

        // Carrega dealers baseado no grupo
        const dealers = await fetchDealers(groupId);

        if (dealers.length > 0) {
          updateSelectOptions(dealerEl, dealers, dealerId, "Todas");

          // Se tem dealer selecionado, carrega atendentes
          if (dealerId && sellerEl) {
            showLoading(sellerEl, "Carregando Atendentes...");
            const sellers = await fetchSellers(dealerId);
            updateSelectOptions(sellerEl, sellers, sellerId, "Todos");
          }
        }
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
        handleLoadError(dealerEl, "Erro ao carregar revendas");
      }
    };

    const fetchGroups = async (companyId) => {
      // Verifica cache primeiro
      if (dataCache.groups.has(companyId)) {
        return dataCache.groups.get(companyId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/groups`, {
          params: { 'q[company_id_eq]': companyId },
          timeout: 5000
        });

        const groups = response.data.groups || [];
        dataCache.groups.set(companyId, groups);
        return groups;
      } catch (error) {
        console.error('Erro ao buscar grupos:', error);
        throw error;
      }
    };

    const handleCompanyChange = async function () {
      const companyId = companyEl.value;

      // Limpa os selects dependentes
      clearSelectElTarget(groupEl, "Selecione a Empresa");
      clearSelectElTarget(dealerEl, "Selecione a Revenda");
      if (sellerEl) clearSelectElTarget(sellerEl, "Selecione o Atendente");
      disableSelect(groupEl);
      disableSelect(dealerEl);
      if (sellerEl) disableSelect(sellerEl);

      if (!companyId) {
        return;
      }

      try {
        showLoading(groupEl, "Carregando empresas...");
        const groups = await fetchGroups(companyId);

        if (groups.length > 0) {
          updateSelectOptions(groupEl, groups, null, "Todas");
        } else {
          handleLoadError(groupEl, "Nenhuma empresa encontrada");
        }
      } catch (error) {
        handleLoadError(groupEl, "Erro ao carregar empresas");
      }
    };

    const fetchDealers = async (groupId) => {
      // Verifica cache primeiro
      if (dataCache.dealers.has(groupId)) {
        return dataCache.dealers.get(groupId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/dealers`, {
          params: { 'q[group_id_eq]': groupId },
          timeout: 5000
        });

        const dealers = response.data.dealers || [];
        dataCache.dealers.set(groupId, dealers);
        return dealers;
      } catch (error) {
        console.error('Erro ao buscar revendas:', error);
        throw error;
      }
    };

    const fetchSellers = async (dealerId) => {
      // Verifica cache primeiro
      if (dataCache.sellers.has(dealerId)) {
        return dataCache.sellers.get(dealerId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/sellers`, {
          params: { 'q[dealer_id_eq]': dealerId },
          timeout: 5000
        });

        const sellers = response.data.sellers || [];
        dataCache.sellers.set(dealerId, sellers);
        return sellers;
      } catch (error) {
        console.error('Erro ao buscar atendentes:', error);
        throw error;
      }
    };

    const updateSelectOptions = (selectEl, items, selectedId, defaultText) => {
      if (isUpdating) return;

      isUpdating = true;

      // Constrói todas as options de uma vez (muito mais rápido)
      const options = [`<option value="">${defaultText}</option>`];

      items.forEach(item => {
        const selected = item.id == selectedId ? 'selected' : '';
        options.push(`<option value="${item.id}" ${selected}>${item.name}</option>`);
      });

      // Atualiza o DOM uma única vez
      selectEl.innerHTML = options.join('');
      enableSelect(selectEl);

      // Atualiza selectpicker usando a forma correta
      refreshSelectPicker(selectEl);
      isUpdating = false;
    };

    // Função auxiliar para refresh correto do selectpicker
    const refreshSelectPicker = (selectEl) => {
      if (!selectEl) return;

      try {
        // Usa a forma específica de acessar o selectpicker
        let [refEl] = Object.values(selectEl).filter(a => a?.liveSearch && a);
        if (refEl && refEl.selectpicker) {
          // Usa setTimeout para evitar conflitos de renderização
          setTimeout(() => {
            refEl.selectpicker.refresh();
          }, 0);
        }
      } catch (error) {
        console.warn('Erro ao atualizar selectpicker:', error);
        // Fallback para método tradicional se houver erro
        if ($(selectEl).data('selectpicker')) {
          $(selectEl).selectpicker('refresh');
        }
      }
    };

    const showLoading = (selectEl, message) => {
      selectEl.innerHTML = `<option value="">${message}</option>`;
      disableSelect(selectEl);
    };

    const handleLoadError = (selectEl, message) => {
      clearSelectElTarget(selectEl, message);
      disableSelect(selectEl);
    };

    const handleGroupChange = async function () {
      // CORRIGIDO: group_id em vez de company_id
      const groupId = groupEl.value;

      // Limpa selects dependentes
      clearSelectElTarget(dealerEl, "Selecione a Empresa");
      if (sellerEl) clearSelectElTarget(sellerEl, "Selecione o Atendente");
      disableSelect(dealerEl);
      if (sellerEl) disableSelect(sellerEl);

      if (!groupId) {
        return;
      }

      try {
        showLoading(dealerEl, "Carregando revendas...");
        const dealers = await fetchDealers(groupId);

        if (dealers.length > 0) {
          updateSelectOptions(dealerEl, dealers, null, "Todas");
        } else {
          handleLoadError(dealerEl, "Nenhuma revenda encontrada");
        }
      } catch (error) {
        handleLoadError(dealerEl, "Erro ao carregar revendas");
      }
    };

    const handleDealerChange = async function () {
      // Se não existe o select de atendente, não faz nada
      if (!sellerEl) return;

      const dealerId = dealerEl.value;

      // Limpa select de atendentes
      clearSelectElTarget(sellerEl, "Selecione o Atendente");
      disableSelect(sellerEl);

      if (!dealerId) {
        return;
      }

      try {
        showLoading(sellerEl, "Carregando atendentes...");
        const sellers = await fetchSellers(dealerId);

        if (sellers.length > 0) {
          updateSelectOptions(sellerEl, sellers, null, "Todos");
        } else {
          handleLoadError(sellerEl, "Nenhum atendente encontrado");
        }
      } catch (error) {
        handleLoadError(sellerEl, "Erro ao carregar atendentes");
      }
    };

    // Limpa cache quando necessário (ex: a cada 5 minutos)
    setInterval(() => {
      dataCache.groups.clear();
      dataCache.dealers.clear();
      dataCache.sellers.clear();
    }, 300000); // 5 minutos

    init();
  }
};

// Inicialização otimizada
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initBackToTop();
    fnScheduledFilters();
  });
} else {
  initBackToTop();
  fnScheduledFilters();
}